import dayjs from 'dayjs';

import { STATE_ABBREVIATIONS } from '~/common/constants/app';
import { isEmptyObject, isValidObject } from '~/common/utils/app';

import { statusOptions } from './constants';

import type { EppoPeakPeriodDataType } from '~/components/Eppo/types';

const validatePeakPeriodDates = (data: EppoPeakPeriodDataType): boolean => {
  const { dates } = data;

  const isValid = Object.values(dates).every(({ from, to }) => {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    if (fromDate.toString() === 'Invalid Date' || toDate.toString() === 'Invalid Date') {
      return false;
    }

    return fromDate < toDate;
  });

  return isValid;
};

const validatePeakPeriodStates = (data: EppoPeakPeriodDataType): boolean => {
  const { dates } = data;

  const isValid = Object.keys(dates).every((key) => {
    const state = key as string;
    return STATE_ABBREVIATIONS.includes(state.toLocaleUpperCase());
  });

  return isValid;
};

export const validatePeakPeriodData = (data: EppoPeakPeriodDataType): boolean =>
  isValidObject(data) &&
  !isEmptyObject(data) &&
  validatePeakPeriodDates(data) &&
  validatePeakPeriodStates(data);

export const getFormattedDates = (dates: { from: string; to: string }): string => {
  const formatString = 'ddd DD MMM';
  const from = dayjs(dates.from).format(formatString);
  const to = dayjs(dates.to).format(formatString);

  return `${from} to ${to}`;
};

export const getPeakRadioOptions = (
  peakDates: { from: string; to: string },
  isSmallScreen: boolean
): Array<{ label: string; value: string }> =>
  statusOptions.map((item) => {
    const viewPortLabel = isSmallScreen ? item.labelMobile : item.label;

    return {
      value: item.value,
      label: viewPortLabel.replace(':dates', getFormattedDates(peakDates)),
    };
  });
